
export class Admin {
    constructor(
        public uid = '',
        public user_id = '',
        public email = '',
        public name = '',
        public sipgateUserId = '',
        public sipgatePhoneId = '',
        public allowCalls = false,
        public isSupport = false,
        public readClients = false,
        public editClients = false,
        public readLeads = false,
        public editLeads = false,
        public readUsers = false,
        public readTickets = false,
        public editTickets = false,
        public allowLogin = false,
        public allowCreateAccount = false,
        public superAdmin = false,
        public disabled = false,
    ) {
    }
}

/*
{
    uid: string,
    name: string,
    accountId: string,
    clientType: string, 'kul' / 'basis' / 'delle' 
}
*/

export class AdminAction {
    constructor(
        public id = '',
        public uid = '',
        public action = '',
        public addInfo = '',
        public at = '',
        public atUnix = 0,
    ) {
    }
}
export class AdminStatus {
    constructor(
        public id = '',
        public uid = '',
        public status = '',
        public at = '',
        public atUnix = 0,
    ) {
    }
}

export class SharedSettings {
    constructor(
        public savedNotizTexts: any = {},
        public teamNews: string = '',
    ) {
    }
}